// Homologa nombres de salas/lugares mostrados en la app: quita el piso antes
// del nombre (p.ej. "Piso 2 - Sala H 201" -> "Sala H 201", "Zócalo - Agora" ->
// "Agora"), unifica guiones y
// corrige errores de tipeo conocidos, sin importar si el nombre viene del
// WordPress (WP) o del grafo local de rutas.
const TYPOS = {
  "Zóclao": "Zócalo",
  "ZÓCLAO": "ZÓCALO"
};

// Palabras sin tilde en el WordPress de origen (no editable desde aquí):
// se corrigen por nombre exacto de palabra, sin importar mayúsculas.
const MISSING_ACCENTS = {
  cafeteria: "Cafetería",
  coordinacion: "Coordinación"
};

const SMALL_WORDS = ["de", "del", "y", "la", "el", "en", "a"];

// Deja "H" + número tal cual (Sala H 204), pone Mayúscula Inicial al resto de
// las palabras (excepto conectores cortos que no van al inicio), para que dé
// lo mismo si el nombre llegó en MAYÚSCULAS (WordPress) o en formato mixto.
const titleCaseWord = (word, index) => {
  if (/^\d+$/.test(word)) return word;
  if (/^H\d+$/i.test(word)) return word.toUpperCase();
  const accentFix = MISSING_ACCENTS[word.toLowerCase()];
  if (accentFix) return accentFix;
  if (index !== 0 && SMALL_WORDS.indexOf(word.toLowerCase()) !== -1) {
    return word.toLowerCase();
  }
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

const titleCaseSegment = segment =>
  segment
    .split(" ")
    .filter(w => w.length > 0)
    .map(titleCaseWord)
    .join(" ");

export const formatDisplayName = text => {
  if (!text) return text;
  let out = text;
  Object.keys(TYPOS).forEach(wrong => {
    out = out.split(wrong).join(TYPOS[wrong]);
  });
  // Unifica variantes de guion (en-dash, em-dash, entidad HTML) a " - ".
  out = out.replace(/&#8211;|&#8212;|[–—]/g, "-").replace(/\s*-\s*/g, " - ");
  // Quita el prefijo de piso al inicio del nombre ("Piso N - " o "Zócalo - ").
  out = out.replace(/^(Piso\s*\d+|Z[oó]calo)\s*-\s*/i, "");
  // ...y al final ("Hall Tecnoaulas - Piso 1" -> "Hall Tecnoaulas").
  out = out.replace(/\s*-\s*Piso\s*\d+\s*$/i, "");
  // Separa "H204" en "H 204" (sin espacio original) antes de homologar mayúsculas.
  out = out.replace(/\bH\s*(\d{3})\b/gi, "H $1");
  // Mayúscula Inicial homogénea en cada segmento separado por " - ".
  out = out.split(" - ").map(titleCaseSegment).join(" - ");
  return out.trim();
};



// WEBPACK FOOTER //
// ./src/utils/nameFormat.js